//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import mainViewMixin from './mainViewMixin';
export default {
  name: 'ViewNiotaClassicServiceBuilders',
  mixins: [mainViewMixin],
  data: function data() {
    return {};
  },
  computed: {
    headerBG: function headerBG() {
      return './img/nr.png';
    },
    buttonsList: function buttonsList() {
      return [];
    }
  },
  methods: {
    pushToRouter: function pushToRouter(path) {
      this.$router.push({
        path: path
      });
    }
  }
};